import AppLogo from "@/components/AppLogo";
import GreenBackgroundShape from "@/components/ui/GreenBackgroundShape";
import { Button } from "@/components/ui/button/button";
import { getHelpCenterUrl } from "@/lib/utils";
import { useAuth } from "@/context/auth-context";
import useSignOutUser from "@/features/auth/useSignOutUser";
import MenuButton from "@/pages/Home/setting/_components/MenuButton";
// import HomeInvite from "../../../components/_module/home/homeInvite";
import { Link } from "@tanstack/react-router";
import {
	Building2,
	HelpCircleIcon,
	LogOutIcon,
	PlusIcon,
	ShieldIcon,
	UserIcon,
	// Users,
} from "lucide-react";

const SettingPage = () => {
	const { signOut } = useSignOutUser();
	const { user } = useAuth();

	const hasFirstNameAndLastName = user.first_name && user.last_name;

	return (
		<div>
			<div className="">
				<GreenBackgroundShape>
					<div className="flex items-center justify-center ">
						<AppLogo theme="light" />
					</div>
					<div className="flex items-center justify-center mt-8">
						{hasFirstNameAndLastName ? (
							<div className="rounded-full bg-secondary w-[5.62rem] h-[5.62rem] flex items-center justify-center">
								<p className="text-4xl font-bold text-secondaryText">
									{user.first_name.slice(0, 1)}
									{user.last_name.slice(0, 1)}
								</p>
							</div>
						) : (
							<div className="rounded-full bg-secondary w-[5.62rem] h-[5.62rem] flex items-center justify-center">
								<UserIcon className="text-white size-12" />
							</div>
						)}
					</div>
					<div className="flex items-center justify-center mt-6">
						<p className="text-2xl text-white font-bold text-center">
							<span className="capitalize">
								{user.first_name?.toLowerCase()}
							</span>{" "}
							<span className="capitalize">
								{user.last_name?.toLowerCase()}
							</span>
						</p>
					</div>
				</GreenBackgroundShape>
			</div>
			<div className="w-full  p-4 mx-auto">
				<Link
					className="border-b m-0 py-3 block border-muted"
					to="/main/setting/personal_info"
				>
					<MenuButton
						label="Personal Info"
						icon={<UserIcon className="w-5 h-5" />}
					/>
				</Link>

				<Link
					className="border-b m-0 py-3 block border-muted"
					to="/main/setting/business-details"
				>
					<MenuButton
						label="Business details"
						icon={<Building2 className="w-5 h-5" />}
					/>
				</Link>

				<Link
					className="border-b m-0 py-3 block border-muted"
					to={"/main/setting/security"}
				>
					<MenuButton
						label="Security"
						icon={<ShieldIcon className="w-5 h-5" />}
					/>
				</Link>
				{/* <Link
					className="border-b m-0 py-3 block border-muted"
					to="/main/setting/referred-friends"
				>
					<MenuButton icon={<Users />} label="Referred Accounts" />
				</Link> */}
				<Link
					to="/main/setting/linked-accounts"
					className="border-b m-0 py-3 block border-muted"
				>
					<MenuButton
						label="Linked Accounts"
						icon={<PlusIcon className="w-5 h-5" />}
					/>
				</Link>
				<Link
					onClick={() => window.open(getHelpCenterUrl(), "_blank")}
					className="border-b m-0 py-3 block border-muted"
					to={"."}
				>
					<MenuButton
						label="Help"
						icon={<HelpCircleIcon className="h-5 w-5" />}
					/>
				</Link>

				<Button
					size={"compact"}
					className="border-b w-full m-0 py-3 block border-muted"
					variant={"unstyled"}
					onClick={signOut}
				>
					<MenuButton
						label="Logout"
						icon={<LogOutIcon className="w-5 h-5" />}
					/>
				</Button>
			</div>
			{/* <div className="px-6">
				<HomeInvite code={user.referral_code} />
			</div> */}
		</div>
	);
};

export default SettingPage;
